import CustomModal from "../CustomModal";

const ViewStaffInfoModal = ({
  isOpen,
  onRequestClose,
  selectedAdmin,
  viewStaffInfo,
  handleShareDetails,
}) => {
  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Password Success Modal"
      className="view-info-modal"
    >
      {viewStaffInfo && (
        <div className="view-info-inner">
          <div className="add-staff-head view-info-head">
            <h2>Staff Info</h2>
          </div>
          <div className="view-staff-name">
            <img
              src={`${process.env.PUBLIC_URL}/images/admin-img.png`}
              alt="Staff profile picture"
            />

            <p className="D">{selectedAdmin.f_name}</p>
            <p className="D">{selectedAdmin.l_name}</p>
          </div>
          <div className="details-container container">
            <div className="detail">
              <p>Email</p>
              <p className="D">{viewStaffInfo.email}</p>
            </div>
            <div className="detail">
              <p>Phone Number</p>
              <p className="D">{viewStaffInfo.phone}</p>
            </div>
            <div className="detail" style={{ marginBottom: "10px" }}>
              <p>Home Address</p>
              <p className="D">{viewStaffInfo.address}</p>
            </div>
            <div className="detail">
              <p>NIN</p>
              <p className="D">{viewStaffInfo.nin}</p>
            </div>
            <div className="detail">
              <p>Role</p>
              <p className="D">
                {viewStaffInfo.role_id === 2
                  ? "Admin"
                  : viewStaffInfo.role_id === 3
                  ? "Super Admin"
                  : viewStaffInfo.role_id === 4
                  ? "Branch Admin"
                  : "Unknown Role"}
              </p>
            </div>
            <div className="detail">
              <p>Password</p>
              <p className="D" style={{ color: "#0473bd", fontSize: "18px" }}>
                {viewStaffInfo.plain_password}
              </p>
            </div>
          </div>
          <div className="view-info-button">
            <button onClick={handleShareDetails}>Share</button>
            <button type="button" onClick={onRequestClose}>
              Cancel
            </button>
          </div>
        </div>
      )}
    </CustomModal>
  );
};

export default ViewStaffInfoModal;
